var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from "@glimmer/tracking";
import RetrieveAndSaveDocuments from "cnam/components/cnam-services-access-form/process/loading";
import ProcessSuccess from "cnam/components/cnam-services-access-form/process/success/index";
import TimedTransaction from "cnam/models/timed-transaction";
import { CnamApiError } from "cnam/utils/cnam-api-errors";
import Ember from "ember";
import ControlTower from "wise-control-tower";
export class State {
  constructor(key, shouldShowState, run, component, loadingComponent) {
    this.key = key;
    this.shouldShowState = shouldShowState;
    this.run = run;
    this.component = component;
    this.loadingComponent = loadingComponent;
    if (component) {
      this.requiresUserAction = true;
    } else {
      this.component = RetrieveAndSaveDocuments;
      this.requiresUserAction = false;
    }
    this.loadingComponent = loadingComponent || RetrieveAndSaveDocuments;
  }
}
let CnamContext = (_class = class CnamContext {
  constructor(store, requestManager, cnamAdapterName, patient, operationType) {
    _initializerDefineProperty(this, "lastError", _descriptor, this);
    _initializerDefineProperty(this, "currentState", _descriptor2, this);
    _initializerDefineProperty(this, "successKey", _descriptor3, this);
    _initializerDefineProperty(this, "loading", _descriptor4, this);
    _initializerDefineProperty(this, "timedTransactions", _descriptor5, this);
    _initializerDefineProperty(this, "currentTimedTransaction", _descriptor6, this);
    _defineProperty(this, "successComponent", ProcessSuccess);
    _defineProperty(this, "transitionTo", async () => {
      this.timedTransactions = [];
      this.loading = true;
      await this._transitionTo();
      this.loading = false;
    });
    _defineProperty(this, "_transitionTo", async () => {
      try {
        if (this.currentState) {
          this.currentTimedTransaction = new TimedTransaction(this.currentState?.key, new Date());
          await this.currentState?.run();
          this.currentTimedTransaction.endDate = new Date();
          this.currentTimedTransaction.success = true;
          this.timedTransactions.push(this.currentTimedTransaction);
        }
        this.currentState = await this.calculateCurrentState();
        if (this.currentState && !this.currentState?.requiresUserAction && !this.successKey) {
          await this._transitionTo();
        }
      } catch (error) {
        if (!Ember.testing) console.error("Error in context", error);
        if (error instanceof CnamApiError && !Ember.testing) {
          console.error("Details", error.error);
          ControlTower.captureException(error);
        }
        this.lastError = error;
        this.currentTimedTransaction.endDate = new Date();
        this.currentTimedTransaction.success = false;
        this.currentTimedTransaction.error = {
          name: error.name,
          message: error.message
        };
        this.timedTransactions.push(this.currentTimedTransaction);
        await this.store.createRecord("cnam-process-ended-journal-event", {
          timedTransactions: this.timedTransactions,
          occurredAt: new Date(),
          patient: this.patient?.isNew ? null : this.patient,
          cnamProcessStartedJournalEvent: this.cnamProcessStartedJournalEvent
        }).save();
        this.onError?.();
      }
    });
    this.store = store;
    this.requestManager = requestManager;
    this.cnamAdapterName = cnamAdapterName;
    this.patient = patient;
    this.operationType = operationType;
    this.states = operationType ? [new State("save-cnam-process-started", () => {
      return Promise.resolve(!this.cnamProcessStartedJournalEvent);
    }, async () => {
      this.cnamProcessStartedJournalEvent = this.store.createRecord("cnam-process-started-journal-event", {
        cnamAdapterName,
        operationType,
        occurredAt: new Date()
      });
      if (this.patient && this.patient.isNew) {
        /*
         * If the patient is not created or persisted yet save the JE without patient
         * Then associate the patient to use the relationship later in the process
         * to persist the relationship in db
         */
        await this.cnamProcessStartedJournalEvent.save();
        this.cnamProcessStartedJournalEvent.patient = this.patient;
      } else {
        /* Otherwise associated the patient and save the JE directly with the
         * patient relationship
         */
        this.cnamProcessStartedJournalEvent.patient = this.patient;
        await this.cnamProcessStartedJournalEvent.save();
      }
    })] : [];
  }
  reset() {
    this.lastError = undefined;
    this.successKey = undefined;
  }
  async calculateCurrentState() {
    for (const state of this.states) {
      if (await state.shouldShowState()) {
        return state;
      }
    }
    return undefined;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "lastError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentState", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "successKey", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "timedTransactions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "currentTimedTransaction", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CnamContext as default };